import { RenderAddressValidationModalProps } from './types';
import { PoMicroFrontend } from 'micro-frontend.react';
import React from 'react';
import { render } from 'base/wrapped-render';

/**
 * Render the address validation modal
 */
export function renderAddressValidationModal({
  onCancel,
  onSave,
  originalAddress,
  suggestedAddress,
}: RenderAddressValidationModalProps): void {
  const rootEl = document.createElement('div');
  document.body.appendChild(rootEl);

  render(
    <PoMicroFrontend
      route="/address-validation/modal"
      pageLoadData={{
        onCancel,
        onSave,
        originalAddress,
        suggestedAddress,
      }}
    />,
    rootEl,
  );
}
